export type SpreadsheetImportField =
  | 'name'
  | 'description'
  | 'status'
  | 'priority'
  | 'begin_date'
  | 'expected_date'
  | 'end_date'
  | 'tags'
  | 'ignore'

export type SpreadsheetImportStatus =
  | 'queued'
  | 'processing'
  | 'mapping_ready'
  | 'importing'
  | 'completed'
  | 'failed'

export type SpreadsheetColumnMapping = {
  column: string
  field: SpreadsheetImportField
  confidence?: 'high' | 'medium' | 'low'
}

export type SpreadsheetTaskImport = {
  id: number
  project_id: number
  status: SpreadsheetImportStatus
  original_filename: string
  columns: string[]
  sample_rows: Array<Record<string, string | null>>
  mapping: SpreadsheetColumnMapping[]
  confirmed_mapping?: SpreadsheetColumnMapping[] | null
  row_count: number
  created_count: number
  skipped_count: number
  error?: string | null
  result?: {
    sheet_name?: string
    ai_used?: boolean
    errors?: string[]
  } | null
  poll_interval_ms?: number
}

export type SpreadsheetTaskImportResponse = {
  message: string
  import: SpreadsheetTaskImport
}

export const SPREADSHEET_IMPORT_FIELDS: Array<{value: SpreadsheetImportField; label: string}> = [
  {value: 'name', label: 'Nome da tarefa'},
  {value: 'description', label: 'Descrição'},
  {value: 'status', label: 'Status'},
  {value: 'priority', label: 'Prioridade'},
  {value: 'begin_date', label: 'Data de início'},
  {value: 'expected_date', label: 'Prazo'},
  {value: 'end_date', label: 'Data de conclusão'},
  {value: 'tags', label: 'Tags'},
  {value: 'ignore', label: 'Ignorar'},
]

export const SPREADSHEET_IMPORT_QUERY_PARAM = 'spreadsheetImport'
